import React from "react";
import style from "./MainContent.module.css";
import Header from "./Header/Header";
import Body from "./Body/Body";
import CookieConsent from "react-cookie-consent";
import Footer from "./Body/Footer/Footer";
import { NavLink } from "react-router-dom";
import WelcomeBanner from "../WelcomeBanner/WelcomeBanner";

const MainContent: React.FC = () => (
  <div className={style.Content}>
    <Header />
    <WelcomeBanner />
    <div className={style.BodyAndFooter}>
      <Body />
      <Footer />
    </div>
    <CookieConsent
      buttonText={"OK"}
      buttonStyle={{
        color: "black",
        fontSize: "12px",
        border: "1px solid black",
      }}
      style={{
        background: "#fff5eb",
        color: "black",
        fontSize: "14px",
        border: "2px solid #ffc246",
      }}
    >
      Serwis wykorzystuje pliki cookies. Korzystając ze strony wyrażasz zgodę na
      wykorzystywanie plików cookies, w zakresie odpowiadającym konfiguracji
      Twojej przeglądarki oraz akceptujesz&nbsp;
      <NavLink
        key={"policy"}
        exact
        to={"/policy"}
        className={style.MenuItem}
      >
        Politykę Prywatności
      </NavLink>
      &nbsp;oraz&nbsp;
      <NavLink
        key={"copyright"}
        exact
        to={"/copy"}
        className={style.MenuItem}
      >
        Regulamin
      </NavLink>
    </CookieConsent>
  </div>
);
export default MainContent;
